import React from 'react';
import Time from '../Time';
import { NavLink } from 'react-router-dom';
import '../css/App.css';
import '../css/bootstrap.min.css';
import '../css/styleCustom.css';
import { FaSortDown,FaSortUp } from "react-icons/fa";


class OrdersList extends  React.Component{
	constructor(props) {
		super(props);
		this.state = {
			user: this.props.user,
			selectedStartDate:'',
			selectedEndDate: '',
			permissions: this.props.permissions,
			activeStore: [],
			allOrdersList: [],
			ordersList: { store: 0, res: [] },
			allStoreOrdersList: [],
			selectedStore: '0',
			scrapedOrder: {},
			scrapedOrderRisk: {},
			query: '',
			filteredData: [],
			isLoading: true,
			currentDateTime: Time.getComputerTimeDate().toString(),
			checkOrderCount: 0,
			showChildComponent:false,
			sort: {
				column: null,
				direction: 'desc',
			},
     // sorted icon state

			storeSorted:0,
			nameSorted:0,
            dateSort:0,
			paymentStatusSort:0

		};
	}

	componentDidMount = async () => {
		await this.loadStore();
		const requests = this.state.activeStore.map( async x => {
			await this.loadOrders(x.id);
		})
		Promise.all(requests).then(() => { this.setState({isLoading: false}) });
	}

   handlePaymentStatusChange = (event) => {
	  if(event.target.value === 'Partially Refunded'){
		const filteredList = this.state.allStoreOrdersList.filter(function (el) {
        return el.financial_status === 'partially_refunded';
	  });
	  this.setState({
			filteredData: filteredList,			
		});
	  }
	  else{
       const filteredList = this.state.allStoreOrdersList.filter(function (el) {
        return el.financial_status === event.target.value.toLowerCase();
	  });
	  this.setState({
			filteredData: filteredList,			
		});
	  }	  
    };

	loadStore = async () => {
		var requestOptions = {
			method: 'GET'
		};
		await fetch("https://dashboard.realsexdoll.info/php/stores/stores.php", requestOptions)
			.then(response => response.json())
			.then(result => {
				this.state.activeStore = result;
			})
			.catch(error => console.log('error', error));
	}

	loadOrders = async (storeId) => {
		let startDateTime = this.state.currentDateTime;
		var formdata = new FormData();
		formdata.append("storeId", storeId);
		formdata.append("startTimeDate", startDateTime);
		var requestOptions = {
			method: 'POST',
			body: formdata,
			redirect: 'follow'
		};
		await fetch("https://dashboard.realsexdoll.info/php/stores/getallorders.php", requestOptions)
			.then(response => response.json())
			.then(result => {
				this.state.allOrdersList.push(this.state.ordersList = { store: storeId, res: result.flat() });
				var joined = this.state.allStoreOrdersList.concat(result.flat());
				if(joined.length > 1){
				const uniqueOrdersList = joined.filter(
                (object, index, self) =>
                index ===
                self.findIndex((o) => o.id === object.id)
                );
				this.setState({ allStoreOrdersList: uniqueOrdersList });
				}
				if(this.state.allOrdersList[this.state.allOrdersList.length - 1].res.length <= 0){
					this.state.checkOrderCount = this.state.checkOrderCount + 1;
				}	
			})
			.catch(error => console.log('error', error));
	}

    distinctOrders = (data) => {
    const uniqueListOfObjects = data.filter(
      (object, index, self) =>
       index ===
       self.findIndex((o) => o.id === object.id)
    );
	this.setState({ allStoreOrdersList: uniqueListOfObjects });
    }

	scrapeOrder = async (storeId, orderId) => {
		var formdata = new FormData();
		formdata.append("storeId", storeId);
		formdata.append("orderId", orderId);
		var requestOptions = {
			method: 'POST',
			body: formdata,
			redirect: 'follow'
		};
		await fetch("https://dashboard.realsexdoll.info/php/scrape/scrapeorder.php", requestOptions)
			.then(response => response.json())
			.then(result => {
				this.state.scrapedOrder = result.order
			})
			.catch(error => console.log('error', error));
	}

	scrapeOrderRisk = async (storeId, orderId) => {
		var formdata = new FormData();
		formdata.append("storeId", storeId);
		formdata.append("orderId", orderId);
		var requestOptions = {
			method: 'POST',
			body: formdata,
			redirect: 'follow'
		};
		await fetch("https://dashboard.realsexdoll.info/php/scrape/shopifyfraudrisk.php", requestOptions)
			.then(response => response.json())
			.then(result => {
				this.state.scrapedOrderRisk = result.risks;
			})
			.catch(error => console.log('error', error));
	}

	handleScrapeOrder = async (orderid, orderStatusUrl) => {
		var storeName = orderStatusUrl.includes("sexdollamerica.com") ? "SD America" : orderStatusUrl.includes("sexdollcanada.com") ? "SD Canada" : "SD Canada";
		var storeId = this.state.activeStore.find(x => x.storeShortName === storeName).id;
		await this.scrapeOrder(storeId, orderid);
		await this.scrapeOrderRisk(storeId, orderid);
		var allRisks = this.state.scrapedOrderRisk;
		let maxRisk = 0.0;
		let riskStatus = "Low";
		allRisks.map(x => {
			if (x.score > maxRisk)
				maxRisk = x.score;
		})
		
		if (maxRisk === 0.0)
			riskStatus = "Low";
		else if (maxRisk === 0.5)
			riskStatus = "Medium";
		else if (maxRisk === 1)
			riskStatus = "High";

			localStorage.setItem('orderDetail', JSON.stringify(this.state.scrapedOrder));
			localStorage.setItem('orderRisk', riskStatus);
		   this.props.history.push({ pathname: `/cookies/poeditor` })
	}

	handleDropdownChange = (event) => {
		this.state.filteredData = [];
		this.setState({ selectedStore: event.target.value })
		if (event.target.value == "0") {
			this.state.allStoreOrdersList = [];
			this.state.allOrdersList.map(x => {
				var joined = this.state.allStoreOrdersList.concat(x.res);
				this.state.allStoreOrdersList = joined.flat();
			})
		}
		else {
			this.state.allStoreOrdersList = this.state.allOrdersList.find(x => x.store === event.target.value).res;
		}
	}

	onSort = (column) => (e) => {
		const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
		const sortedData = this.state.allStoreOrdersList.sort((a, b) => {
			if (column === 'store') {
				this.setState({storeSorted : this.state.storeSorted+1})
				const nameA = a.order_status_url.toUpperCase();
				const nameB = b.order_status_url.toUpperCase();
				if (nameA < nameB) {
					return -1;
				}
				if (nameA > nameB) {
					return 1;
				}
				console.log(this.state.storeSorted)
				return 0;
			}
			else if (column === 'name') {
				this.setState({nameSorted : this.state.nameSorted+1})
				const nameA = a.name.toUpperCase();
				const nameB = b.name.toUpperCase();
				if (nameA < nameB) {
					return -1;
				}
				if (nameA > nameB) {
					return 1;
				}
				return 0;
			}
			else if (column === 'date') {
				this.setState({dateSort:this.state.dateSort+1})
				const nameA = a.created_at.toUpperCase();
				const nameB = b.created_at.toUpperCase();
				if (nameA < nameB) {
					return -1;
				}
				if (nameA > nameB) {
					return 1;
				}
				return 0;
			}
			else if (column === 'status') {

				this.setState({paymentStatusSort:this.state.paymentStatusSort+1})
				const nameA = a.financial_status.toUpperCase();
				const nameB = b.financial_status.toUpperCase();
				if (nameA < nameB) {
					return -1;
				}
				if (nameA > nameB) {
					return 1;
				}
				return 0;
			}
			else {
				return a.contractValue - b.contractValue;
			}
		});
		if (direction === 'desc') {
			this.setState({storeSorted : this.state.storeSorted+1})
			sortedData.reverse();
		}
		this.setState({
			data: sortedData,
			sort: {
				column,
				direction,
			}
		});
	};

	handleInputChange = (event) => {
		this.setState({ query: event.target.value })
	}

	handleInputSubmit = () => {
		this.state.filteredData = [];
		let searchString = this.state.query;
		let filteredData = this.state.allStoreOrdersList;
		if (searchString.length > 0) {
			filteredData = filteredData.filter(element => {
				return element.name.toLowerCase().includes(searchString.toLowerCase());
			});
			this.setState({
				filteredData
			})
		}
		else {
			this.setState({
				filteredData: []
			})
		}
	}


	handleInputLoadMore = async () => {
		this.state.filteredData = [];
		this.state.checkOrderCount = 0;
		this.state.isLoading = true;	
		function pad2(number) {return (number < 10 ? '0' : '') + number}
		const date = new Date(this.state.currentDateTime);
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const hour = date.getHours(), min = date.getMinutes();
        const today = (year - 1) + "-" + pad2(month) + "-" + pad2(day) + "T" + pad2(hour) + ":" + pad2(min);
		this.state.currentDateTime = today;	
		const requests = this.state.activeStore.map( async x => {
			await this.loadOrders(x.id);
		})
		Promise.all(requests).then(() => { this.setState({isLoading: false}) });
	}

	handleStartDateChange = (event) => {
    this.setState({ selectedStartDate: event.target.value });	
    };

	handleEndDateChange = (event) => {
    this.setState({ selectedEndDate: event.target.value });	
    };

	filterOnDateRange = () => {
	let sDate = this.state.selectedStartDate + 'T00:00:00-00:00';
	let eDate = this.state.selectedEndDate + 'T00:00:00-00:00'
	 const filteredList = this.state.allStoreOrdersList.filter(function (el) {
        return el.created_at >=  sDate && el.created_at <=  eDate;
	  });
	   this.setState({
			filteredData: filteredList,			
		});
	}

	render() {
	    const staticPaymentStatuses = ['All', 'Paid', 'Pending', 'Partially Refunded', 'Voided', 'Refunded'];
		const store = this.state.activeStore;
		let correctAllStoreOrdersList = this.state.allStoreOrdersList.filter( (ele, ind) => ind === this.state.allStoreOrdersList.findIndex( elem => elem.id === ele.id))
		const order = this.state.filteredData.length > 0 ? this.state.filteredData : this.state.sort.column != null ? correctAllStoreOrdersList : correctAllStoreOrdersList.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
		const options = {
			year: "numeric",
			month: "long",
			weekday: "long",
			day: "numeric",
			hour: "numeric",
			minute: "numeric",
			hour12: true
		};
		return (
			this.state.isLoading ?	
			<div className="divLoader">
			<svg className="svgLoader" viewBox="0 0 100 100" width="10em" height="10em">
			  <path ng-attr-d="{{config.pathCmd}}" ng-attr-fill="{{config.color}}" stroke="none" d="M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50" fill="#51CACC" transform="rotate(179.719 50 51)"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 51;360 50 51" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform></path>
			</svg>
		  </div> :
		  	<div className="row">
				<div className='col-md-2'>
					<aside className='sidebar'>
						<div className='sidebar-menu'>
							<ul className="list-group p-3">
								<li className="list-group-item active" aria-current="true"><a className='text-decoration-none' href='/cookies/orderslist'>Home</a></li>
								<li className="list-group-item"><a className='text-decoration-none' href='#'>Stores</a></li>
								<NavLink to={`/vendors/vendorlist`} className="btn-base">Vendors</NavLink>
							</ul>
						</div>
					</aside>
				</div>
				<div className='col-md-10'>
					<div className="orderlist-container p-3">
						<div className='container-fluid'>
							<div className='bg-white rounded px-4 py-5'>
								<div className="row">
									<div className="col-6">
										<select id="dropdown" className='form-select mb-4' value={this.state.selectedStore} onChange={this.handleDropdownChange}>
											<option value="0">All Store</option>
											{store.map((data) => (
												<option key={data.id} value={data.id}>{data.storeShortName}</option>
											))}
										</select>
									</div>
									<div className="col-6">
										<div className='row g-2 mb-4'>
											<div className="col-7">
												<input className='form-control' autoComplete='off' type="text" ref="Search" id="filter" placeholder="Search Shopify Order" value={this.state.query} onChange={this.handleInputChange} />
											</div>										
											<div className="col-2">
												<button className='btn-outline-base' onClick={this.handleInputSubmit}>Search</button>
											</div>
										</div>
									</div>
									<div className='col-3'>
										<div className='mb-4'>
												<label className='form-label'>
														Payment Status
												</label> 
													<select className='form-select'
													value={this.state.selectedPaymentStatus}
													onChange={this.handlePaymentStatusChange}>
													{staticPaymentStatuses.map((status) => (
														<option key={status} value={status}>
														{status}
													</option>
													))}
													</select>  
											</div>
									</div>
									<div className="col-3">
										<div className='mb-4'>
											<label htmlFor="inputtext" className="form-label">
											Start Date:
											</label>
											<input className='form-control'
											type="date"
											id="dateInput"
											name="selectedStartDate"
											value={this.state.selectedStartDate}
											onChange={this.handleStartDateChange}
											/>
										</div>
									</div>
									<div className="col-2">
										<div className='mb-4'>
											<label htmlFor="inputtext" className="form-label">
											End Date:
											</label>
											<input
											className='form-control'
											type="date"
											id="dateInput"
											name="selectedEndDate"
											value={this.state.selectedEndDate}
											onChange={this.handleEndDateChange}
											/>
										</div>
									</div>
									<div className="col-2 align-self-end">
										<div className='mb-4'>
											<label htmlFor="inputtext" className="form-label d-block fs-0"></label>
											<button className='btn-base' onClick={this.filterOnDateRange}>Filter By Dates</button>
										</div>
									</div>
									<div className="col-2 align-self-end">
										<div className='mb-4'>
											<label htmlFor="inputtext" className="form-label d-block fs-0"></label>
										{ this.state.checkOrderCount < 2 && 
											<button className='btn-outline-base' onClick={this.handleInputLoadMore}>Load More</button>}
										</div>
									</div>
								</div>
							</div>
							<hr />
							<div className='col-12'>
								<div className='wrapper h-100 bg-white border border-1'>
									<table className="table table-striped">
										<thead>
											<tr>
												{this.state.storeSorted%2 === 0 && <th onClick={this.onSort('store')}>Store Name <FaSortUp /></th>}
												{this.state.storeSorted%2 !== 0 && <th onClick={this.onSort('store')}>Store Name<FaSortDown /></th>}
                                                
                                                 {this.state.nameSorted%2===0 &&
													<th onClick={this.onSort('name')}>Shopify Order Number<FaSortUp /></th>}

                                                 {this.state.nameSorted%2!==0 &&
												<th onClick={this.onSort('name')}>Shopify Order Number<FaSortDown /></th>
												 }


                                                   {this.state.dateSort%2===0 &&

												<th onClick={this.onSort('date')}>Date<FaSortUp /></th>
												   }

												   {this.state.dateSort%2!==0 &&

                                                 <th onClick={this.onSort('date')}>Date<FaSortDown /></th>
                                                           }

												<th>Total</th>
                                                 
												 {this.state.paymentStatusSort%2 ===0 &&
												<th onClick={this.onSort('status')}>Payment Status <FaSortUp /></th>		
												 }
												 {this.state.paymentStatusSort%2 !==0 &&
												<th onClick={this.onSort('status')}>Payment Status <FaSortDown /></th>		
												 }


												<th>Action</th>
											</tr>
										</thead>
										<tbody>
											{order.map((data) => (
												<tr key={data.id}>
													<td>{data.order_status_url.includes("sexdollamerica.com") ? "SD America" : data.order_status_url.includes("sexdollcanada.com") ? "SD Canada" : "SD Canada"}</td>
													<td>{data.name}</td>
													<td>{new Date(data.created_at).toLocaleDateString("en-US", options)}</td>
													<td>${data.total_price}</td>
													<td>{data.financial_status}</td>
													<td><button className='btn-base' onClick={() => { this.handleScrapeOrder(data.id, data.order_status_url); }}>SCRAPE</button></td>
												</tr>
											))}
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default OrdersList;